<template>
  <div
    v-tippy="{ placement: 'right', content: hideTooltip ? null : title, delay }"
    :class="['navbar__link', isActive && 'router-link-active']"
  >
    <router-link :to="to" :aria-label="title" @click="handleAnalytics">
      <slot :active="isActive" />
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { delay } from '@/components/Tippy'
import analytics from '@/utils/analytics'

const props = defineProps<{
  title: string
  to: {
    name: string
    params?: Record<string, string | string[]>
  }
  hideTooltip?: boolean
  linkActive?: boolean
}>()

const route = useRoute()
const isActive = computed(() => route.name?.toString().startsWith(props.to.name) || props.linkActive)

const handleAnalytics = () => {
  if (!isActive.value) {
    analytics.navbarEvent('Clicked navbar link', props.title)
  }
}
</script>
